import React from 'react';
import { Icon, Icons, Typography, styled } from '@nextiva/next-ui-components';
import { formattedLicensePricingDataType } from 'types/purchaseLicenseModalTypes';

const StyledContainer = styled('div')`
  display: flex;
  justify-content: space-between;
  margin-top: 45px;
  padding: 0px 127px 0px 80px;
`;
const StyledLabelText = styled(Typography)`
  font-weight: 800;
  font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  line-height: 20px;
  color: ${({ theme }) => theme.palette.secondary.contrastText};
  margin-bottom: 4px;
`;
const StyledArrowIcon = styled(Icon)`
  transform: rotate(180deg) scale(1.31);
  fill: ${({ theme }) => theme.palette.blueGrey.A400};
  margin-top: 24px;
`;
const StyledBillText = styled(Typography)`
  color: ${({ theme }) => theme.palette.secondary.contrastText};
`;
const StyledTaxesText = styled(Typography)`
  color: ${({ theme }) => theme.palette.secondary.contrastText};
  display: block;
  margin-top: 8px;
`;

const CURRENT_BILL_TEXT = 'Current monthly bill';
const NEW_BILL_TEXT = 'New monthly bill *';
const TAXES_TEXT = 'Additional taxes and fees will apply';

interface IMonthlyBill {
  formattedLicensePricingData: formattedLicensePricingDataType;
  didInitialLicensePricingDataApiCallFail: boolean;
}

export const MonthlyBill = ({
  formattedLicensePricingData,
  didInitialLicensePricingDataApiCallFail,
}: IMonthlyBill) => (
  <StyledContainer>
    <div>
      <StyledLabelText>{CURRENT_BILL_TEXT}</StyledLabelText>
      <StyledBillText variant="h4">
        {didInitialLicensePricingDataApiCallFail
          ? '--'
          : formattedLicensePricingData?.totalCurrentMonthlyCharges}
      </StyledBillText>
      <StyledTaxesText variant="caption">{TAXES_TEXT}</StyledTaxesText>
    </div>
    <StyledArrowIcon icon={Icons.back} />
    <div>
      <StyledLabelText>{NEW_BILL_TEXT}</StyledLabelText>
      <StyledBillText variant="h4">
        {didInitialLicensePricingDataApiCallFail
          ? '--'
          : formattedLicensePricingData?.totalNewMonthlyCharges}
      </StyledBillText>
    </div>
  </StyledContainer>
);
